import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Reveel from './Reveel';
import AdminPanel from './AdminPanel';
import BlogDetail from './BlogDetail';
import ResetPassword from './ResetPassword';
import PrivacyPolicyPage from './PrivacyPolicyPage';
import TermsAndConditionsPage from './TermsAndConditionsPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Reveel />} />
        <Route path="/admin" element={<Navigate to="/admin/analytics" replace />} />
        <Route path="/admin/:tab" element={<AdminPanel />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditionsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
